import { applyMiddleware, combineReducers, compose, createStore } from 'redux'
import thunk from 'redux-thunk'
import userReducer from './user'
import taskReducer from './task'
import pathReducer from './path'
import audioReducer from './audio'
import layoutOptionsReducer from './layoutOptions'
import { loadState, saveState } from './localStorage'
import throttle from 'lodash/throttle'

export default function() {
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

  const persistedState = loadState()

  const reducers = combineReducers({
    user: userReducer,
    task: taskReducer,
    path: pathReducer,
    audio: audioReducer,
    layoutOptions: layoutOptionsReducer,
  })

  const store = createStore(
    reducers,
    persistedState,
    composeEnhancers(applyMiddleware(thunk))
  )

  // Throttling save state to every 200 milliseconds for performance (just in case)
  store.subscribe(
    throttle(() => {
      saveState(store.getState())
    }, 200)
  )

  return store
}



// WEBPACK FOOTER //
// ../core/src/store/create.js